import { Renderer2 } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

// React Imports
import { BehaviorSubject, Subscription } from 'rxjs';
// React Imports
import { InfomapModel } from 'src/app/models/main/deals/infomap.model';
import { TenReasonsModel } from 'src/app/models/main/tenreasons/tenreasons.model';
import { TenReasonsService } from 'src/app/services/tenreasons.service';


// Global site text import
//import { dealsText } from '../../../app.component';

@Component({
    selector: 'top-reasons-why',
    templateUrl: './top-reasons.component.html',
    styleUrls: ['./top-reasons.component.scss'],
    standalone: false
})

export class TopReasonsPage implements OnInit {
   // site text variables for localization
   TenReasons: TenReasonsModel[] = [];
   constructor(
    private tenReasonsData: TenReasonsService,
    ) {
  }

  public ngOnInit() : void {
    //TODO something
    this.TenReasons = this.tenReasonsData.getTenReasons();
  }
}
